export enum ErrorMsg {
  POSITION_INVENTORY_SHORTAGE = '库存扣减失败：岗位库存不足',
  COURSE_TOTAL_INVENTORY_SHORTAGE = '库存扣减失败：课程在该地区总库存不足',
  COURSE_NON_PREMIUM_INVENTORY_SHORTAGE = '库存扣减失败：课程在该地区非状元库存不足',
  DUPLICATE_ORDER_SUBMISSION = '请勿重复提交订单',
  BLACKLIST = '用户已被列入黑名单，无法下订单',
}
export enum CommonErrorMsg {
  REFRESH_EXPIRE = 'refreshToken失效',
  NO_REFRESHTOKEN = 'refreshToken不存在',
  REFRESH_FAIL = 'token刷新失败',
  CANCEL_SELECT_ROOM = '取消选择房间',
  UNPAID_ACCOMMODATION_FEE = '住宿费用尚未支付成功',
}
